const rarity_options = [
  { key: 'all', value: '< ALL >'},
  { key: 'r5', value: '5'},
  { key: 'r4', value: '4'},
  { key: 'r3', value: '3'},
  { key: 'r2', value: '2'},
]

const exclusive_options = [
  { key: 'all', value: '< ALL >'},
  { key: 'c_weapon', value: '[ Weapons ]'},
  { key: 'sword', value: 'Sword'},
  { key: 'blade', value: 'Blade'},
  { key: 'dagger', value: 'Dagger'},
  { key: 'axe', value: 'Axe'},
  { key: 'lance', value: 'Lance'},
  { key: 'bow', value: 'Bow'},
  { key: 'wand', value: 'Wand'},
  { key: 'staff', value: 'Staff'},
  { key: 'c_element', value: '[ Elements ]'},
  { key: 'flame', value: 'Flame'},
  { key: 'water', value: 'Water'},
  { key: 'wind', value: 'Wind'},
  { key: 'light', value: 'Light'},
  { key: 'shadow', value: 'Shadow'}
]

const condition_options = [
  { key: 'all', value: '< ALL >'},
  { key: 'hfl', value: 'Full HP'},
  { key: 'h70', value: 'HP 70%'},
  { key: 'lst', value: 'Last'},
  { key: 'dbb', value: 'DoubleBuff'},
  { key: 'flr', value: 'Flurry'},
  { key: 'hts', value: 'Hits'},
  { key: 'stk', value: 'Force Strike'},
  { key: 'stkr', value: 'Striker'},
  { key: 'slyr', value: 'Slayer'},
  { key: 'unt', value: 'United'},
  { key: 'rsl', value: 'Resilient'}
]

const effect_options = [
  { key: 'all', value: '< ALL >'},

  { key: 'c_atk', value: '[ Attack Type ]'},
  { key: 'skl_dmg', value: 'Skill Damage'},
  { key: 'str', value: 'Strength'},
  { key: 'crt_rt', value: 'Critical Rate'},
  { key: 'crt_dmg', value: 'Critical Damage'},
  { key: 'frc_stk', value: 'Force Strike'},
  { key: 'enr', value: 'Energy'},

  { key: 'c_pns', value: '[ Punisher Type ]'},
  { key: 'ovd_pns', value: 'Overdrive Punisher'},
  { key: 'brk_pns', value: 'Broken Punisher'},
  { key: 'psn_pns', value: 'Poision Punisher'},
  { key: 'brn_pns', value: 'Burning Punisher'},
  { key: 'frz_pns', value: 'Freeze Punisher'},
  { key: 'prl_pns', value: 'Paralysis Punisher'},
  { key: 'bln_pns', value: 'Blindness Punisher'},
  { key: 'stn_pns', value: 'Stun Punisher'},
  { key: 'crs_pns', value: 'Curse Punisher'},
  { key: 'bg_pns', value: 'Bog Punisher'},
  { key: 'slp_pns', value: 'Sleep Punisher'},

  { key: 'c_sp', value: '[ Special Type ]'},
  { key: 'skl_prp', value: 'Skill Prep'},
  { key: 'skl_chr', value: 'Skill Charge'},
  { key: 'skl_hst', value: 'Skill Haste'},
  { key: 'bf_tm', value: 'Buff Time'},
  { key: 'gg_acl', value: 'Gauge Accelerator'},
  { key: 'gg_inh', value: 'Gauge Inhibitor'},

  { key: 'c_drg', value: '[ Shapeshift Type ]'},
  { key: 'shs_prp', value: 'Shapeshift Prep'},
  { key: 'drg_dmg', value: 'Dragon Damage'},
  { key: 'drg_tm', value: 'Dragon Time'},
  { key: 'drg_clw', value: 'Dragon\'s Claws'},

  { key: 'c_dfn', value: '[ Defense Type ]'},
  { key: 'hp', value: 'HP'},
  { key: 'dfn', value: 'Defense'},
  { key: 'shl_prp', value: 'Shield Prep'},

  { key: 'c_dbf_rs', value: '[ Affliction Res Type ]'},
  { key: 'afl_grd', value: 'Affliction Guard'},
  { key: 'psn_rs', value: 'Poision Res'},
  { key: 'brn_rs', value: 'Burn Res'},
  { key: 'frz_rs', value: 'Freeze Res'},
  { key: 'prl_rs', value: 'Paralysis Res'},
  { key: 'bln_rs', value: 'Blindness Res'},
  { key: 'stn_rs', value: 'Stun Res'},
  { key: 'crs_rs', value: 'Curse Res'},
  { key: 'bg_rs', value: 'Bog Res'},
  { key: 'slp_rs', value: 'Sleep Res'},

  { key: 'c_el_rs', value: '[ Element Res Type ]'},
  { key: 'flm_rs', value: 'Flame Res'},
  { key: 'wtr_rs', value: 'Water Res'},
  { key: 'wnd_rs', value: 'Wind Res'},
  { key: 'lgh_rs', value: 'Light Res'},
  { key: 'shd_rs', value: 'Shadow Res'},

  { key: 'c_rc_rs', value: '[ Race Res Type ]'},
  { key: 'hmd_rs', value: 'High Midgardsormr Res'},
  { key: 'hbr_rs', value: 'High Brunhilda Res'},
  { key: 'hmr_rs', value: 'High Mercury Res'},
  { key: 'hjp_rs', value: 'High Jupiter Res'},
  { key: 'hzd_rs', value: 'High Zodiark Res'},
  { key: 'md_rs', value: 'Midgardsormr Res'},
  { key: 'br_rs', value: 'Brunhilda Res'},
  { key: 'mr_rs', value: 'Mercury Res'},
  { key: 'jp_rs', value: 'Jupiter Res'},
  { key: 'zd_rs', value: 'Zodiark Res'},

  { key: 'c_hl', value: '[ Heal Type ]'},
  { key: 'rcv_ptn', value: 'Recovery Potency'},
  { key: 'hl', value: 'Heal'},

  { key: 'c_other', value: '[ Others ]'},
  { key: 'exp', value: 'Player EXP Increase'}
]

const type_options = [
  { key: 'all', value: '< ALL >'},
  { key: 'common', value: 'Permanent'},
  { key: 'seasonal', value: 'Seasonal'},
  { key: 'event', value: 'Event'},
  { key: 'collab', value: 'Collab'},
  { key: 'promo', value: 'Promo'}
]

const Options = {
  rarity    : rarity_options,
  exclusive : exclusive_options,
  condition : condition_options,
  effect    : effect_options,
  type      : type_options
}

export default Options